__turbopack_context__.v({
  "is-active": "index-module-scss-module__BaxsPq__is-active",
  "is-disabled": "index-module-scss-module__BaxsPq__is-disabled",
  "pagination__container": "index-module-scss-module__BaxsPq__pagination__container",
});
